const ModalPosition = {
  TOP: 'top',
  CENTER: 'center',
};

ModalPosition.propTypes = Object.values(ModalPosition);

export default ModalPosition;
